// @flow
import { useState, useCallback, useEffect } from 'react';

import { api, requestsGeneral } from 'app/api';

import type { AssigmentType, AssignmentsRequestResult } from './types';


const defaultAssignments = [];

export default function useAssignments(scheduleIds: Array<number> | number): Array<AssigmentType> {
  const [assignments, setAssignments] = useState<Array<AssigmentType>>(defaultAssignments);

  /**
   *  ЗАПРОС ДОМАШНИХ ЗАДАНИЙ И ИХ ПРИЛОЖЕНИЙ, НАЗНАЧЕННЫХ УЧИТЕЛЕМ
   */

  const handleRequestAssignments = useCallback(async (scheduleIds_: Array<number> | number = scheduleIds) => {
    const assignmentsRes: AssignmentsRequestResult | null = await api.request(
      requestsGeneral.Homework_GET_assignments, {
        error: 'Не удалось получить вложения к домашним заданиям',
        params: {
          schedule_id: !(scheduleIds_ instanceof Array) ? [scheduleIds_] : scheduleIds_,
        },
      }
    );
    if (assignmentsRes && assignmentsRes.data) {
      setAssignments(assignmentsRes.data);
      return true;
    }
    return false;
  }, [scheduleIds]);


  useEffect(() => {
    handleRequestAssignments();
  }, [handleRequestAssignments]);


  return assignments;
}
